import { combineReducers } from 'redux';

import loaderReducer from './loaderReducer';
import authReducer from './authReducer';

export default combineReducers({
  showLoader: loaderReducer,
  auth: authReducer,
});
